export default __webpack_public_path__ + "static/media/ionic.a3aed90f.svg";